import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { relationSchema } from "../../domain/models/RelationModel";
import useCrudTable from "../../../../hooks/useCrudTable";
import useCrudFilters from "../../../../hooks/useCrudFilters";
import { RelationTableFilters } from "../features/RelationTableFilters";
import { relationColumns } from "../../domain/models/RelationColumns";
import { useAuthorization } from "../../../../hooks/useAuthorization";
import React from "react";

export const RelationsPage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const { hasRole } = useAuthorization();

  const title = t("Dealers");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootRelation",
      fields: {},
    },
    "relationFilter",
  );

  const addAction = () => {
    if (hasRole("dealer-employee")) {
      return undefined;
    }
    return "/relations/add";
  };

  const crud = useCrudTable({
    prefix: "relations",
    entity: "Relation",
    columns: relationColumns,
    schema: relationSchema,
    addAction: addAction(),
    columnAction: "/relations/edit/:id",
    bulkFields: [
      {
        field: "status",
        options: [
          { label: "Active", value: "true" },
          { label: "Inactive", value: "false" },
        ],
        date: false,
      },
    ],
    defaultSorting: [
      {
        id: "name",
        desc: false,
      },
    ],
    filters: crudFilters.filters,
  });

  if (
    hasRole("dbh-employee") ||
    hasRole("dbh-driver") ||
    hasRole("dbh-order-picker")
  ) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <RelationTableFilters {...crudFilters} />
          {crud.bulk}
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
